import React, { Component } from "react"
import { StaticQuery, graphql } from "gatsby"

import Link from "../../utils/link"
import ShopifyTags from "../../utils/shopify-tags"

import MobileMenu from "./mobile-menu"
import ShopMobileMenu from "./shop-mobile-menu"

class Header extends Component {
  constructor(props) {
    super(props)

    let uniqueBrands = []

    this.props.data.allShopifyProduct.nodes.map((node) => {
      let index = uniqueBrands.findIndex(
        (el) => el.key === node.vendor.toLowerCase()
      )
      if (index === -1) {
        uniqueBrands.push({
          key: node.vendor.toLowerCase(),
          value: 1,
        })
      } else {
        uniqueBrands[index].value++
      }
    })

    uniqueBrands.sort((a, b) => b.value - a.value)

    uniqueBrands = uniqueBrands.map((el) => el.key)

    this.state = {
      offCanvas: false,
      shopMenu: false,
      collection: this.props.context.collection || null,
      tag: this.props.context.tag || null,
      brand: this.props.context.brand || null,
      brands: uniqueBrands,
    }
  }

  componentDidMount() {
    window._shopMenu = () => {
      this.setState({ shopMenu: !this.state.shopMenu })
    }
  }

  headerLeave = () => {
    if (window.innerWidth > 900) {
      this.setState({ shopMenu: false })
    }
  }

  render() {
    let { offCanvas, shopMenu, collection, tag } = this.state

    const menuHandler = () => {
      this.setState({ offCanvas: !offCanvas })
    }

    const shopHandler = () => {
      this.setState({ shopMenu: !shopMenu })
    }

    let props = {
      className: "navbar__navlink",
      activeClassName: "navbar__menu-active",
      onClick: (event) => {
        this.setState({
          collection: null,
          tag: null,
          brand: null,
          shopMenu: event.target.innerText.toLowerCase() === "shop",
        })
      },
    }

    let subMenu = []

    const handle =
      typeof collection === "number" &&
      this.props.data?.allShopifyCollection?.nodes[collection]?.handle

    const collections = this.props.data.allShopifyCollection.nodes.map(
      (el, i) => {
        subMenu.push(el)

        const onClick = (event) => {
          this.setState({ collection: i })
        }

        return (
          <Link
            to={`/shop/${el.handle}/`}
            key={i}
            className={i === collection ? "active" : ""}
            onClick={onClick}
          >
            {el.title}
          </Link>
        )
      }
    )

    let tags =
      typeof collection === "number" &&
      ShopifyTags[handle]?.map((el, i) => (
        <Link
          to={`/shop/${subMenu[collection].handle}/${el}`}
          className={tag === el ? "active" : ""}
          onClick={() => this.setState({ tag: el })}
          key={i}
        >
          {el}
        </Link>
      ))

    if (collection === "brands") {
      tags = this.state.brands.slice(0, 7).map((el, i) => (
        <Link
          to={`/shop/${el.replace(/ /g, "-")}/`}
          className={this.state.brand === el ? "active" : ""}
          onClick={() => this.setState({ brand: el })}
          key={i}
        >
          {el}
        </Link>
      ))
    }

    const { optionsAcf } = this.props.data.wp.siteSettings

    return (
      <>
        {optionsAcf.enableHeaderAnnouncement && (
          <div className="header__announcement">
            <div dangerouslySetInnerHTML={{ __html: optionsAcf.headerAnnouncement }} />
          </div>
        )}
        <header
          id="header"
          name="header"
          className={`header ${offCanvas || shopMenu ? "header--open" : ""} ${optionsAcf.enableHeaderAnnouncement ? "header--announcement" : ""}`}
          onMouseLeave={this.headerLeave}
        >
          <div className="container">
            <div className="navbar__top-left">
              <Link
                to="https://lafacebeautyclinic.mylocalsalon.com/OnlineBooking"
                className="navbar__navlink"
              >
                <svg
                  width="20px"
                  height="20px"
                  viewBox="0 0 20 20"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="#E84734"
                    fillRule="nonzero"
                  >
                    <path d="M16.5714286,1.61904762 L14.952381,1.61904762 L14.952381,0 L13.9047619,0 L13.9047619,1.61904762 L5.33333333,1.61904762 L5.33333333,0 L4.28571429,0 L4.28571429,1.61904762 L2.66666667,1.61904762 C1.23809524,1.61904762 0,2.76190476 0,4.28571429 L0,16.5714286 C0,18.0952381 1.23809524,19.2380952 2.66666667,19.2380952 L16.5714286,19.2380952 C18.0952381,19.2380952 19.2380952,18 19.2380952,16.5714286 L19.2380952,6.95238095 L19.2380952,5.9047619 L19.2380952,4.28571429 C19.2380952,2.76190476 18.0952381,1.61904762 16.5714286,1.61904762 Z M18.1904762,16.5714286 C18.1904762,17.4285714 17.4285714,18.1904762 16.5714286,18.1904762 L2.66666667,18.1904762 C1.80952381,18.1904762 1.04761905,17.4285714 1.04761905,16.5714286 L1.04761905,6.95238095 L18.1904762,6.95238095 L18.1904762,16.5714286 Z M18.1904762,5.9047619 L1.04761905,5.9047619 L1.04761905,4.28571429 C1.04761905,3.42857143 1.80952381,2.66666667 2.66666667,2.66666667 L4.28571429,2.66666667 L4.28571429,3.71428571 L5.33333333,3.71428571 L5.33333333,2.66666667 L13.9047619,2.66666667 L13.9047619,3.71428571 L14.952381,3.71428571 L14.952381,2.66666667 L16.5714286,2.66666667 C17.4285714,2.66666667 18.1904762,3.42857143 18.1904762,4.28571429 L18.1904762,5.9047619 Z"></path>
                  </g>
                </svg>
                <span>Book now</span>
              </Link>
            </div>
            <ul className="navbar navbar--desktop">
              {this.props.data.wpMenu.menuItems.nodes.map((el, i) => (
                <li key={i}>
                  <Link
                    to={el.path}
                    {...props}
                    onMouseEnter={() => this.setState({ shopMenu: false })}
                  >
                    {el.label}
                  </Link>
                </li>
              ))}
            </ul>
            <ul className="navbar navbar--mobile">
              <li>
                <button
                  type="button"
                  className="mobileMenu__btn"
                  onClick={menuHandler}
                >
                  Clinic
                </button>
              </li>
              <li>
                <Link
                  to="/shop/"
                  className="mobileMenu__btn"
                  //onClick={shopHandler}
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/cart/" className="mobileMenu__btn">
                  Bag ({this.props.cartCount})
                </Link>
              </li>
            </ul>
            <div className="navbar__top-right">
              <Link to="/cart/" {...props}>
                <span>Bag ({this.props.cartCount})</span>
                <svg
                  width="17px"
                  height="20px"
                  viewBox="0 0 17 20"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="#E84734"
                    fillRule="nonzero"
                  >
                    <path d="M15.7505176,3.94482964 L12.0108696,3.94482964 C11.570911,1.82761284 9.50310559,0.444940649 7.30331263,0.877025709 C5.7194617,1.17948525 4.48757764,2.38932342 4.17960663,3.94482964 L0.439958592,3.94482964 C0.175983437,3.94482964 0,4.11766366 0,4.3769147 L0,19.4134748 C0,19.6727258 0.175983437,19.8455598 0.439958592,19.8455598 C0.439958592,19.8455598 0.439958592,19.8455598 0.439958592,19.8455598 L15.7505176,19.8455598 C16.0144928,19.8455598 16.1904762,19.6727258 16.1904762,19.4134748 C16.1904762,19.4134748 16.1904762,19.4134748 16.1904762,19.4134748 L16.1904762,4.3769147 C16.1904762,4.16087217 16.0144928,3.94482964 15.7505176,3.94482964 Z M8.0952381,1.65477882 C9.50310559,1.65477882 10.7349896,2.60536595 11.0869565,3.94482964 L5.10351967,3.94482964 C5.45548654,2.60536595 6.6873706,1.65477882 8.0952381,1.65477882 Z M15.310559,18.9813897 L0.879917184,18.9813897 L0.879917184,4.80899976 L4.09161491,4.80899976 L4.09161491,6.5805485 C4.09161491,6.83979954 4.26759834,7.01263356 4.5315735,7.01263356 C4.79554865,7.01263356 4.97153209,6.83979954 4.97153209,6.5805485 L4.97153209,4.80899976 L11.1749482,4.80899976 L11.1749482,6.5805485 C11.1749482,6.83979954 11.3509317,7.01263356 11.6149068,7.01263356 C11.878882,7.01263356 12.0548654,6.83979954 12.0548654,6.5805485 L12.0548654,4.80899976 L15.2665631,4.80899976 L15.2665631,18.9813897 L15.310559,18.9813897 Z"></path>
                  </g>
                </svg>
              </Link>
            </div>
          </div>

          <div className="header__logo">
            <Link to="/">
              <svg
                width="231px"
                height="40px"
                viewBox="0 0 231 40"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>LaFace Logo</title>
                <g
                  stroke="none"
                  strokeWidth="1"
                  fill="#F0533F"
                  fillRule="nonzero"
                >
                  <path
                    d="M4.33086971,1.35696449 L4.33086971,36.3805644 L24.8297193,36.3805644 L23.6716075,39.2487024 L0.135087719,39.2487024 L0.135087719,1.35696449 L4.33086971,1.35696449 Z M41.0270109,23.930422 L54.9840206,23.930422 L47.9512716,7.31138045 L41.0270109,23.930422 Z M49.803708,0.977239186 L65.9955752,39.2487024 L61.41466,39.2487024 L56.0716151,26.6369747 L39.8797479,26.6369747 L34.5909471,39.2487024 L31.1572948,39.2487024 L47.0209851,2.12718745 L49.803708,0.977239186 Z M128.821105,23.930422 L142.778114,23.930422 L135.745365,7.31138045 L128.821105,23.930422 Z M137.597802,0.977239186 L153.789669,39.2487024 L149.208754,39.2487024 L143.865709,26.6369747 L127.676554,26.6369747 L122.387753,39.2487024 L118.954101,39.2487024 L134.817791,2.12718745 L137.597802,0.977239186 Z M95.8759438,1.35696449 L91.6774496,1.35696449 L91.6774496,39.2487024 L95.8759438,39.2487024 L95.8759438,22.0344886 L110.852743,22.0344886 L112.010855,19.1663506 L95.8759438,19.1663506 L95.8759438,4.22510243 L115.159725,4.22510243 L116.320549,1.35696449 L95.8759438,1.35696449 Z M208.031068,1.35696449 L203.832574,1.35696449 L203.832574,39.2487024 L228.950309,39.2487024 L230.108421,36.3805644 L208.031068,36.3805644 L208.031068,21.2238693 L223.007867,21.2238693 L224.168691,18.3530383 L208.031068,18.3530383 L208.031068,4.22510243 L228.296668,4.22510243 L229.45478,1.35696449 L208.031068,1.35696449 Z M190.884504,31.1613613 C187.806151,34.5950476 183.333724,36.7710621 178.337841,36.7710621 C169.056674,36.7710621 163.594292,29.300438 163.594292,20.0846934 C163.594292,10.8689487 169.056674,3.39832464 178.337841,3.39832464 C183.189977,3.39832464 187.553916,5.44776405 190.62142,8.71447891 L193.284806,7.43795555 C189.685709,3.26097719 184.348089,0.600206968 178.3731,0.600206968 C167.535127,0.600206968 158.747581,9.32580972 158.747581,20.0873865 C158.747581,30.8489632 167.535127,39.5745659 178.3731,39.5745659 C184.207054,39.5745659 189.430762,37.0322916 193.024435,33.0195915 L191.291335,31.4953041 L190.884504,31.1613613 Z"
                    id="Shape"
                  ></path>
                </g>
              </svg>
            </Link>
          </div>

          <div className={`shop-menu ${shopMenu ? "active" : ""}`}>
            <div className="shop-menu__inner">
              <div className="shop-menu__collections">
                {collections}
                <Link
                  to={`/shop/gifts/`}
                  className={"gifts" === collection ? "active" : ""}
                  onClick={() =>
                    this.setState({
                      collection: "gifts",
                      tag: null,
                      brand: null,
                    })
                  }
                >
                  {"Gifts"}
                </Link>
                <Link
                  to={`/shop/`}
                  className={"brands" === collection ? "active" : ""}
                  onClick={() =>
                    this.setState({
                      collection: "brands",
                      tag: null,
                      brand: null,
                    })
                  }
                >
                  {"Brands"}
                </Link>
              </div>
              <div className="shop-menu__sub-menu">{tags}</div>
            </div>
          </div>
        </header>

        <MobileMenu
          active={offCanvas}
          menuHandler={menuHandler}
          close={() => this.setState({ offCanvas: false })}
        />
        <ShopMobileMenu
          active={shopMenu}
          menuHandler={shopHandler}
          close={() => this.setState({ shopMenu: false })}
          collections={this.props.data.allShopifyCollection.nodes}
          subMenu={subMenu}
          brands={this.state.brands}
        />
      </>
    )
  }
}

export default function HeaderQueryWrap(props) {
  return (
    <StaticQuery
      query={graphql`
        query HeaderQuery {
          allShopifyProduct {
            nodes {
              vendor
            }
          }
          allShopifyCollection {
            nodes {
              handle
              title
              products {
                tags
              }
            }
          }
          wpMenu(locations: { eq: GATSBY_HEADER_MENU }) {
            menuItems {
              nodes {
                label
                path
              }
            }
          }
          wp {
            siteSettings {
              optionsAcf {
                enableHeaderAnnouncement
                headerAnnouncement
              }
            }
          }
        }
      `}
      render={(data) => <Header data={data} {...props} />}
    />
  )
}
